import type { CarFeatureConfig } from '../../../types/insurances/CarFeatureConfig';

export const car: CarFeatureConfig = {
    overview: {
        details: {
            showPackage: true,
            showRisksInList: false,
            showSpecialTranslationKeyForParticipationAllRisks: false,
            fallbackAssistancePhonesKey: 'SK',
            fallbackAssistanceEmailsKey: null,
        },
    },
    history: {
        visible: false,
    },
};
